/**
 * 📄 UsuarioPage.jsx
 * Página wrapper para usuarios
 */
import React from "react";
import UsuarioList from "../components/Usuario/UsuarioList";

export default function UsuarioPage() {
    return <UsuarioList />;
}
